var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "password-reset" }, [
    !_vm.emailSent
      ? _c("div", { staticClass: "columns is-multiline" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "column is-4 mx-auto" }, [
            _vm.errors
              ? _c(
                  "div",
                  { staticClass: "errors mb-2" },
                  [
                    _vm._l(_vm.errors, function(item) {
                      return [
                        Array.isArray(item)
                          ? _vm._l(item, function(error) {
                              return _c("div", { staticClass: "error" }, [
                                _vm._v(_vm._s(error))
                              ])
                            })
                          : [
                              _c("div", { staticClass: "error" }, [
                                _vm._v(_vm._s(item))
                              ])
                            ]
                      ]
                    })
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "form d-flex flex-column justify-content-center",
                attrs: { role: "form", method: "POST" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.submit($event)
                  }
                }
              },
              [
                _c("input", {
                  attrs: { type: "hidden", name: "_token" },
                  domProps: { value: _vm.csrfToken }
                }),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "hidden", name: "token" },
                  domProps: { value: _vm.token }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "field mb-6",
                    class: { "has-error": _vm.$v.email.$error }
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "label mb-1", attrs: { for: "email" } },
                      [_vm._v("Email Address*")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "control" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.$v.email.$model,
                            expression: "$v.email.$model",
                            modifiers: { trim: true }
                          }
                        ],
                        staticClass: "input",
                        attrs: {
                          name: "email",
                          id: "email",
                          type: "email",
                          autofocus: ""
                        },
                        domProps: { value: _vm.$v.email.$model },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.$v.email,
                              "$model",
                              $event.target.value.trim()
                            )
                          },
                          blur: function($event) {
                            return _vm.$forceUpdate()
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.$v.$dirty && _vm.$v.email.$invalid
                      ? _c("div", { staticClass: "error" }, [
                          _vm._v(_vm._s(_vm.emailErrorMessage))
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "field mb-5" }, [
                  _c(
                    "label",
                    { staticClass: "label mb-1", attrs: { for: "password" } },
                    [_vm._v("Password*")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.$v.password.$model,
                          expression: "$v.password.$model",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "input",
                      attrs: {
                        id: "password",
                        name: "password",
                        type: "password"
                      },
                      domProps: { value: _vm.$v.password.$model },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.$v.password,
                            "$model",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field mb-5" }, [
                  _c(
                    "label",
                    {
                      staticClass: "label mb-1",
                      attrs: { for: "passwordConfirmation" }
                    },
                    [_vm._v("Confirm Password*")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.$v.passwordConfirmation.$model,
                          expression: "$v.passwordConfirmation.$model",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "input",
                      attrs: {
                        id: "passwordConfirmation",
                        name: "password_confirmation",
                        type: "password"
                      },
                      domProps: { value: _vm.$v.passwordConfirmation.$model },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.$v.passwordConfirmation,
                            "$model",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "field mb-3 mx-auto" },
                  [
                    !_vm.loading
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-form",
                            attrs: { type: "submit" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.submit($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Reset your\n                        password\n                    "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.loading
                      ? _c("pulse-loader", {
                          attrs: {
                            loading: true,
                            color: "#E57722",
                            size: "20px"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.emailSent
      ? _c("div", { staticClass: "notification columns is-multiline" }, [
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "column is-full mb-4" }, [
            _c("p", { staticClass: "w-648 t-black mx-auto text-center" }, [
              _vm._v("We’ve sent an email to "),
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(_vm._s(_vm.email))
              ]),
              _vm._v(
                "\n                where you’ll be able to click the reset link and create a new password for your account."
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-full mb-1" }, [
      _c("h1", { staticClass: "mx-auto text-center" }, [
        _vm._v("Reset your password")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "column d-flex justify-content-center mb-1" },
      [
        _c("img", {
          staticClass: "icon__email-sent",
          attrs: { src: "/img/icons/email-sent.svg", alt: "Email icon" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-full mb-1" }, [
      _c("h1", { staticClass: "w-872 mx-auto text-center" }, [
        _vm._v("Check your email to reset your password!")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33eb8e7d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33eb8e7d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/forms/passwords/Reset.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-33eb8e7d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/forms/passwords/Reset.vue
// module chunks = 0 1